<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><a id="title"></a><em>Machiavelli in Love</em></h1>
<p class="subtitle">Sex, Self, and Society in the Italian Renaissance</p>
<p class="author">GUIDO RUGGIERO</p>
<p class="image1"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?756f34a1